export enum DeviceState {
	Offline = 'OFFLINE',
	Discovered = 'DISCOVERED',
	Online = 'ONLINE',
	Error = 'ERROR',
	// Default state when the device's actual status doesn't match known states.
	Unknown = 'UNKNOWN'
}
